<template>
  <div>
    <v-row >
      <v-col cols="12" v-if="isMobile">
        <div v-if="isMobile" style="width:100%; overflow-x:auto  ">

          <div class="d-inline-flex justify-space-between">
            <big-round-button color="primary" class="mr-2 mb-2" icon="mdi-domain" text="ΚΤΗΡΙΟ"
                              :to="'/building/'+branchDetails.Branch_ID"></big-round-button>
            <big-round-button color="primary" class="mr-2 mb-2" icon="mdi-compare-horizontal" text="ΚΙΝΗΣΕΙΣ"
                              :to="'/building/'+branchDetails.Branch_ID+'/partnerMoves'"
                              v-if="userDetails.Allows.ShowDeptsMoves"></big-round-button>
          </div>
        </div>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-row>
            <v-col cols="12">
              <iframe v-if="isMobile" frameborder="0" width="100%" height="200px"
                      :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyB2jrpRoYbO4bYF3W9EYmgQ5xrGszVfIDk&q='+branchDetails.BranchLAT+','+branchDetails.BranchLONG+'&zoom=16'"/>
            </v-col>
            <v-col lg="6" sm="12" md="6" v-if="!isMobile">
              <iframe v-if="!isMobile" frameborder="0" width="100%" height="200px"
                      :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyB2jrpRoYbO4bYF3W9EYmgQ5xrGszVfIDk&q='+branchDetails.BranchLAT+','+branchDetails.BranchLONG+'&zoom=16'"/>
            </v-col>
            <v-col lg="6" sm="12" md="6">
              <v-list nav color="transparent">
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>mdi-map</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ branchDetails.BranchAddress }}, {{ branchDetails.BranchAreaName }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Διεύθυνση
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>mdi-city</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ branchDetails.BranchDimosName }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Δήμος
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>mdi-briefcase</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ branchDetails.PartnerBrandName }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Πελάτης
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="fill-height">
          <v-card-title>
            <wnl-text>Ανυψωτικά </wnl-text>Κτηρίου ({{ branchDetails.Projects.length }})
          </v-card-title>
          <project-list :project-items="branchDetails.Projects"></project-list>

        </v-card>
      </v-col>
      <v-col  v-if="userDetails.Allows.ShowRepresentative && branchDetails.Representative">
        <v-card>
          <v-card-title> Eπαφές κτηρίου</v-card-title>
          <v-card-text>
            <v-list>
              <v-list-item>
                <v-list-item-action>
                  <v-icon>mdi-account-box-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ branchDetails.Representative.Name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Εκπρόσωπος
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-for="phone in branchDetails.Representative.Phones">
                <v-list-item-action>
                  <v-icon>mdi-phone</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ phone.Value }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ phone.PhoneType }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content>
                  {{ phone.Notes }}
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col lg="12" sm="7" cols="12">
        <v-card v-if="userDetails.Allows.ShowDeptsMoves || userDetails.Allows.ShowDepts">
          <v-card-title>
            Συμφωνητικό
          </v-card-title>
          <v-card-text>
            Συχνότητα χρέωσης
            <v-simple-table dense fixed-header>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">Ιαν</th>
                  <th class="text-left">Φεβ</th>
                  <th class="text-left">Μαρ</th>
                  <th class="text-left">Απρ</th>
                  <th class="text-left">Μάης</th>
                  <th class="text-left">Ιουν</th>
                  <th class="text-left">Ιουλ</th>
                  <th class="text-left">Αυγ</th>
                  <th class="text-left">Σεπτ</th>
                  <th class="text-left">Οκτ</th>
                  <th class="text-left">Φλεβ</th>
                  <th class="text-left">Δεκ</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td v-for="month in branchDetails.SixnotitaXreosis">
                    <v-icon small v-if="month">mdi-check-circle</v-icon>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-list color="transparent">
            <v-list-item>
              <v-list-item-action>
                <v-icon>mdi-cash</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Χρέωση/συντήρηση
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <span style="font-size: 1.6em"> {{ branchDetails.PosoXreosis |fixed }}‎€ </span>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {BranchDetails} from "../../../wl-core/api/classes/BranchDetails";
import {mapGetters} from "vuex";
import ProjectList from "@/views/Projects/components/ProjectList";
import BigRoundButton from "@/components/BigRoundButton";
import WnlText from "@/wl-unit-text/WnlText";

export default {
  name: "BuildingDetails",
  components: {WnlText, BigRoundButton, ProjectList},
  computed: {
    ...mapGetters([
      "userDetails",
      "isMobile"
    ]),
    ...mapGetters('branch', [
      "branchDetails"
    ])
  }
}
</script>

<style scoped>
td{
  padding:0 5px 0 5px !important;
}
th{
  padding:0 5px 0 5px !important;
}

</style>
